import type { GetEntitiesByFpIdTimelineData } from '@onefootprint/request-types/dashboard';
import useEntityId from './use-entity-id';
import useEntityTimeline from './use-entity-timeline';
const useCurrentEntityTimeline = query => {
  const id = useEntityId();
  return useEntityTimeline(id, query);
};
export default useCurrentEntityTimeline;